import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useChangelog() {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const token = window.localStorage.getItem('token');

    setLoading(true);
    setError(null);

    axios.get('/api/changelog', { params: { token } })
      .then((res) => {
        if (cancelled) return;
        if (res.data && res.data.success) {
          setVersions(res.data.versions || []);
        } else {
          setError(res.data?.error || 'Не удалось загрузить changelog');
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Ошибка сети');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { versions, loading, error };
}
